// frontend/src/api/valuationIndustryFacts.ts
//
// VAL-INDUSTRY-FACTS-1C — the server's field list for an industry's facts
// (apps/api/routers/_valuation_industries.py). The list and labels live on the
// server; nothing about them is written in the browser.

import { apiClient } from '@/api/client'
import type { IndustryFactFieldsResponse } from '@/types/valuationCompany'

const BASE = '/v1/valuation'

export async function fetchIndustryFactFields(industry: string): Promise<IndustryFactFieldsResponse> {
  const { data } = await apiClient.get<IndustryFactFieldsResponse>(
    `${BASE}/industry-facts/fields`,
    { params: { industry } },
  )
  return data
}
